import { InspectionPlugin } from './inspectionPlugin.model';
import { Inspection } from './inspection.model';
import { InspectionSection } from './inspectionSection.model';
import { InspectionFolder } from './inspectionFolder.model';
import { ISearch } from './ISearch.model';
import { Icon } from './icon.model';
import { IInspectionVisitor } from './IInspectionVisitor.model';
import { IHost } from './IHost.model';
import { InspectionSession } from './multi-edit.model';

export class InspectionPoint implements ISearch, IHost {
  public static Draft = 0;
  public static Done = 100;
  public static NotApplicable = 200;

  public plugins: InspectionPlugin[] = [];
  public sectionId: string;
  public folderId: string;
  public inspection: Inspection;
  public section: InspectionSection;
  public folder: InspectionFolder;
  public status: number;
  public notes: string;
  public order: number;
  public icons: Icon[] = [];
  public comment: string;
  public reason: string;
  // temporary
  public type = 200;
  public inspectionId: string;
  public etag: Date;
  public sessions: InspectionSession[];

  constructor(public id: string, public name: string, public description: string) {
    this.plugins = [];
    this.icons = [];
    this.sessions = [];
  }

  get sessionIcons(): InspectionSession[] {
    return this.inspection.sessions?.map((s) => {
      const entitySession = new InspectionSession();
      Object.assign(entitySession, s);
      entitySession.highlight = this.sessions?.includes(s);
      return entitySession;
    });
  }

  public search(query: string): boolean {
    const queryToLower = query.toLowerCase();
    return (
      this.name == null ||
      this.name.toLowerCase().indexOf(queryToLower) !== -1 ||
      this.description == null ||
      this.description.toLowerCase().indexOf(queryToLower) !== -1
    );
  }

  public accept(visitor: IInspectionVisitor): void {
    this.plugins.forEach((point) => point.accept(visitor));
  }

  public isDone(): boolean {
    const result = this.status === InspectionPoint.Done || this.status === InspectionPoint.NotApplicable;
    return result;
  }

  public isNotApplicable() {
    return this.status === InspectionPoint.NotApplicable;
  }

  public isDraft() {
    return this.status === InspectionPoint.Draft;
  }
}
